/* eslint-disable indent */
import { CheckpointTypeFilterType } from '@/entities/checkpoint';
import { EquipmentDmgFilterType } from '@/entities/equipment';
import { StructureAdvancedFilter } from '@/entities/structure/group';
import { UserFilterType } from '@/entities/user';
import { VehiculeCheckFilterType } from '@/entities/vehicle';
import { Equipment } from '@/api/entities/equipment';

export const mapStructureFilterAPI = (filter: StructureAdvancedFilter) =>
  `key=${filter.key}${
    filter.isDistributor ? '&isDistributor=' + filter.isDistributor : ''
  }${filter.isBranch ? '&isBranch=' + filter.isBranch : ''}${
    filter.isWhiteMark ? '&isWhiteMark=' + filter.isWhiteMark : ''
  }${filter.startDate ? '&startDate=' + filter.startDate : ''}${
    filter.endDate ? '&endDate=' + filter.endDate : ''
  }${filter.groupId ? '&groupId=' + filter.groupId : ''}${
    filter.distributorId ? '&distributorId=' + filter.distributorId : ''
  }${filter.companyId ? '&companyId=' + filter.companyId : ''}${
    filter.role ? '&role=' + filter.role : ''
  }${filter.userId ? '&userId=' + filter.userId : ''}
  ${filter.branchId ? '&branchId=' + filter.branchId : ''}`;

export const mapFilterSelect = (data) => {
  const mappedData = Array.isArray(data)
    ? data.map((item) => {
      const clientValue = item?.firstname && item?.lastname ? 
        `${item?.firstname}_separator_${item?.lastname}` : (item?.firstname || item?.lastname || item?.email);
      
      const clientLabel = item?.firstname && item?.lastname ?
        `${item?.firstname} ${item?.lastname?.toUpperCase()}` :
        (item?.firstname || item?.lastname || item?.email);

      return {
        value: item?.id || clientValue,
        label: item?.name || clientLabel
      }
    })
    : [];

  return mappedData;
};

export const mapUserFilterAPI = (filter: UserFilterType) =>
  `key=${filter.key}${filter.role ? '&role=' + filter.role : ''}${
    filter.status ? '&status=' + filter.status : ''
  }${filter.groupId ? '&groupId=' + filter.groupId : ''}${
    filter.companyId ? '&companyId=' + filter.companyId : ''
  }${filter.branchId ? '&branchId=' + filter.branchId : ''}${
    filter.userId ? '&userId=' + filter.userId : ''
  }${filter.roleFilter ? '&roleFilter=' + filter.roleFilter : ''}`;

export const mapVehicleFilterAPI = (filter: VehiculeCheckFilterType) =>
  `key=${filter.key ?? ''}${filter.role ? '&role=' + filter.role : ''}${
    filter.userId ? '&userId=' + filter.userId : ''
  }${filter.vehiculeId ? '&vehiculeId=' + filter.vehiculeId : ''}${
    filter.actionUserId ? '&actionUserId=' + filter.actionUserId : ''
  }${filter.status ? '&status=' + filter.status : ''}${
    filter.type ? '&type=' + filter.type : ''
  }${filter.startDate ? '&startDate=' + filter.startDate : ''}${
    filter.endDate ? '&endDate=' + filter.endDate : ''
  }${filter.groupId ? '&groupId=' + filter.groupId : ''}${
    filter.companyId ? '&companyId=' + filter.companyId : ''
  }${filter.branchId ? '&branchId=' + filter.branchId : ''}${
    filter.requestInspection
      ? '&requestInspection=' + filter.requestInspection
      : ''
  }`;

export const mapEquipmentFilterAPI = (filter: EquipmentDmgFilterType) =>
  `key=${filter.key ?? ''}${filter.status ? '&status=' + filter.status : ''}${
    filter.isMultiple ? '&isMultiple=' + filter.isMultiple : ''
  }${filter.sortBy ? '&sortColumn=' + filter.sortBy : ''}
  ${filter.sortDirection ? '&sortDirection=' + filter.sortDirection : ''}`;

export const mapDmgFilterAPI = (filter: EquipmentDmgFilterType) =>
  `key=${filter.key ?? ''}${filter.status ? '&status=' + filter.status : ''}`;

export const mapCheckpointTypeFilterAPI = (filter: CheckpointTypeFilterType) =>
  `key=${filter.key ?? ''}${filter.status ? '&status=' + filter.status : ''}${
    filter.type ? '&type=' + filter.type : ''
  }`;

export const mapVehiclesImport = (vehicles: object[], vehiculeOwner) =>
  vehicles
    .map((item) => {
      const data = Object.values(item);
      return {
        brand: data[0],
        model: data[1].toString(),
        vin: data[2],
        licensePlateNumber: data[3],
        yearOfFirstRegistration: data[4],
        mileage: data[5],
        comment: data[6],
        picture: data[7],
        ownerType: vehiculeOwner.ownerType,
        ownerGroupId: vehiculeOwner.ownerGroupId || '',
        ownerCompanyId: vehiculeOwner.ownerCompanyId || '',
      };
    })
    .filter(
      (vehicle) =>
        vehicle.brand &&
        vehicle.model &&
        vehicle.vin &&
        vehicle.licensePlateNumber &&
        vehicle.yearOfFirstRegistration &&
        vehicle.mileage &&
        vehicle.comment &&
        vehicle.picture
    );

  export const mapEquipmentOptions = (equipments: Equipment[] | null | undefined) => {
    if (!Array.isArray(equipments)) {
      return [{ label: 'Aucune option disponible', id: 'none' }];
    }
    return [
      { label: 'Pas de translation automatique', id: 'none' },
      ...equipments.map((item) => ({
        label: item.name,
        id: item.id,
      })),
    ];
  };

  export const mapEquipmentInfosDefaultValues = (data: Equipment, translatedEquipment: Equipment) => {
    return {
      ...data as Equipment,
      name: translatedEquipment?.name || data?.name || '',
      comment: translatedEquipment?.comment || data?.comment || '',
      isFrontPart: data?.isFrontPart || false,
      isBackPart: data?.isBackPart || false,
      isLeftPart: data?.isLeftPart || false,
      isRightPart: data?.isRightPart || false,
      frontPartTranslation: data?.frontPartTranslation || 'none',
      backPartTranslation: data?.backPartTranslation || 'none',
      leftPartTranslation: data?.leftPartTranslation || 'none',
      rightPartTranslation: data?.rightPartTranslation || 'none',
    };
  };
